var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rest-form-item',{attrs:{"label":_vm.$t('ChannelConfig_Facebook_AccessToken'),"prop":"access_tokej"}},[_c('el-input',{model:{value:(_vm.model.params.access_token),callback:function ($$v) {_vm.$set(_vm.model.params, "access_token", $$v)},expression:"model.params.access_token"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52302aae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/channels/providers/Facebook.vue
// module id = null
// module chunks = 